import { useGetRecentColleagues } from "@src/appV2/Agents/api/useGetRecentColleagues";

import { useGetFriendsList } from "../WorkWithFriends/hooks/useGetFriendsList";
import { useGetOutboundFriendsRequests } from "../WorkWithFriends/hooks/useGetOutboundFriendsRequests";

interface UseFriendsAndColleaguesDataProps {
  hideAsColleagueOnShifts?: boolean;
}

export function useFriendsAndColleaguesData(props: UseFriendsAndColleaguesDataProps) {
  const { hideAsColleagueOnShifts } = props;

  const { data: friendsList } = useGetFriendsList();
  const friendsMap = new Map(friendsList?.data.map((friend) => [friend.id, friend]));

  const { data: recentColleaguesData } = useGetRecentColleagues({
    enabled: !hideAsColleagueOnShifts,
  });

  const recentColleaguesMap = new Map(
    recentColleaguesData?.map((colleague) => [colleague.colleagueUserId, colleague])
  );

  const { data: outboundFriendRequests } = useGetOutboundFriendsRequests();

  const outboundFriendRequestsSet = new Set(
    outboundFriendRequests?.data.map((worker) => worker.id)
  );

  return {
    friendsMap,
    recentColleaguesMap,
    outboundFriendRequestsSet,
  };
}
